var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67 57",
    width: 67,
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h200v57h-200z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #5932f3 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m64.4 24.3c0 0-1.1-1-1.7-1.1-0.1 0-0.4 0-0.3 0.2 0.5 1.6 0.5 2.4 0.5 2.4 0 0 2.4 1.9 2.8 2.3 0.4 0.4 0.4 0.2 0.3 0-0.1-1-1.1-3-1.6-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m48.4 36.1c0.2 0.8 0.8 1.2 1.4 1.2 0.7 0 1.3-0.6 1.3-1.2 0-0.3-0.1-0.5-0.1-0.7q-0.1-0.1-0.1-0.2c-0.8-3.4-0.8-6.8-0.3-10.2 0.5-2.9 3-5.6 6.2-5.6 1.6 0 3 0.5 4.1 1.4 2.2 0.8 4 3.3 4 5.7-2 0-4.3-1.2-5.4-3.1-0.6-0.6-1.4-1-2.3-1-1.6 0-2.9 1.2-3.2 2.7-0.5 3.5-0.6 6.9 0.3 10.3 0.2 0.5 0.4 1.3 0.5 2.2 1.6 10.2-8.5 18.5-19 18.5q-0.6 0-1.2 0-2.2-0.1-4.2-0.7c2.2-1 3.8-3.1 4.4-5.5 1.4-5.3 5.4-9.6 10.5-11.6q1.7-0.1 3.3-0.4c-2.9-3.4-4.9-7.4-5.9-11.8-0.3-1.4-1.2-2.8-2.7-3.5-0.6-0.4-1.3-0.5-2-0.6q-4.2-0.3-8.3-1.2-2.7-2.5-5.2-5.3c-0.3-0.2 0.1-0.6 0.4-0.5q1.9 1.1 3.9 2-0.1-0.1-0.2-0.2h-0.1c-0.7-0.8-1.5-1.7-2.2-2.5q-1.6-2-3.1-4c-0.2-0.3 0.2-0.6 0.5-0.4q1.7 1 3.4 2-4.1-5.4-6.9-11.3c-0.2-0.4 0.3-0.7 0.6-0.3q0.9 1.2 2 2.4c6.3 7.5 13.9 13.4 22.2 17.4 0.6 0.3 1.3 0.7 1.7 1.2 1.1 1.3 1.5 2.8 1.2 4.3-0.5 3.5-0.3 7 0.5 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m9.8 16.4q-1.5-0.7-2.8-1.4c-0.4-0.2-0.7 0.3-0.4 0.5q5 4.2 11 7.4-2-0.2-3.9-0.5c-0.4 0-0.6 0.5-0.3 0.7q2.2 1.2 4.5 2.2c1 0.5 2 0.9 3.1 1.4q0.1 0 0.3 0.1-2.2 0-4.4-0.2c-0.3 0-0.5 0.5-0.1 0.7q3.8 1.6 7.8 2.8-2 0.1-4.1 0.2c-0.3 0-0.4 0.5-0.1 0.7q0.8 0.2 1.5 0.4 5.1-1 10-2.8c0.7-0.2 1.4-0.4 2.1-0.4 1.6 0.2 3 1 3.9 2.1 2.6 3.4 5.9 6.1 9.7 7.9q0.8-0.1 1.5-0.3c-3.2-3.1-5.6-7.2-6.8-11.4-0.4-1.5-1.5-2.7-2.9-3.4-0.7-0.3-1.4-0.4-2.1-0.4-9.2-0.1-18.6-2.2-27.5-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0.6 35.5q1.5 0.1 3.1 0.1c9.9 0 19.2-2.1 27.6-5.9 0.7-0.3 1.4-0.5 2.1-0.5 1.6 0 3.1 0.7 4.1 1.8 2.9 3.3 6.6 5.9 10.9 7.4-4.3 3.3-9 6.1-13.9 8.3-0.3 0.1-0.6-0.2-0.5-0.5q0.4-1 0.7-2-1.8 1-3.8 1.8c-0.2 0.1-0.5-0.1-0.4-0.4q0.4-1 0.8-2.1-3 1.2-6.2 2.1c-0.3 0.1-0.6-0.3-0.3-0.6q1.3-0.9 2.5-1.9-3.8 0.8-7.7 1.2c-0.4 0-0.6-0.5-0.2-0.6q1.8-1 3.5-2-4 0.7-8.2 0.8c-0.4 0-0.5-0.5-0.1-0.7q2-0.7 3.9-1.6c-1.2 0-2.4 0.1-3.6 0.1q-2.6 0-5-0.2c-0.4 0-0.4-0.5-0.1-0.7q1.9-0.5 3.7-1.2-6.7-0.4-13-2c-0.4-0.1-0.3-0.7 0.1-0.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.8e4240a69582cb2354361cf9d050af30.svg";
export { ForwardRef as ReactComponent };